import { orchestrator } from 'satcheljs';
import getItemIdsToShowFromNodeIds from 'owa-mail-store/lib/selectors/getItemIdsToShowFromNodeIds';
import { listViewStore } from 'owa-mail-list-store';
import setItemsFlagStateFromNodeIds from '../actions/actionCreators/setItemsFlagStateBasedOnNodeIds';
import { setItemsFlagStateFromItemIds } from '../actions/setItemsFlagState';

export default orchestrator(setItemsFlagStateFromNodeIds, actionMessage => {
    const itemIds = getItemIdsToShowFromNodeIds(actionMessage.nodeIds);
    const tableView = listViewStore.tableViews.get(actionMessage.tableViewId);

    setItemsFlagStateFromItemIds(
        itemIds,
        null,
        { FlagStatus: actionMessage.flagStatusToSet },
        tableView.id,
        actionMessage.actionSource
    );
});
